<template>
    <inertia-link :href="'/'">
        <img src="/images/logo-intimateinteractive-220x50.png">
    </inertia-link>
</template>
